module.exports = __webpack_public_path__ + "img/icon_map_shljx.e5f99e30.png";